<template>
    <div :class="labelClass">
        <i v-show="icon" :class="icon" style="margin-right: 10px;"></i>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "mc-label",
        props: {
            icon:       {type: String, default: ""},
            title:      {type: Boolean, default: false},
            success:    {type: Boolean, default: false},
            info:       {type: Boolean, default: false},
            warn:       {type: Boolean, default: false},
            error:      {type: Boolean, default: false}
        },
        computed: {
            labelClass: function(){
                let str = "mc-label";
                let arr = ["title", "success", "info", "warn", "error"];
                for(let i in arr){
                    if(this[arr[i]]) str = `${str} ${arr[i]}`
                }
                return str;
            },
        },
    }
</script>

<style lang="less" scoped>
    .mc-label {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        min-height: 40px;
        padding: 10px 15px;
        background-color: #ffffff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        &.title {
            background-color: #f5f7fa;
            color: #909399;
            border-color: #dcdfe6;
        }
        &.success {
            background-color: #f0f9eb;
            color: #67C23A;
            border-color: #e1f3d8;
        }
        &.info {
            background-color: #edf2fc;
            color: #909399;
            border-color: #ebeef5;
        }
        &.warn {
            background-color: #fdf6ec;
            color: #E6A23C;
            border-color: #faecd8;
        }
        &.error {
            background-color: #fef0f0;
            color: #F56C6C;
            border-color: #fde2e2;
        }
    }
</style>